// src/components/InstallBanner.jsx
import { usePWAInstall } from "../hooks/useMobile";
import { B, fonts } from "./UI";

export default function InstallBanner() {
  const { install, dismiss, showBanner } = usePWAInstall();

  if (!showBanner) return null;

  return (
    <div style={{
      position: "fixed", bottom: 80, left: 16, right: 16, zIndex: 500,
      background: B.headerBg, border: `1.5px solid ${B.orange}`,
      borderRadius: 16, padding: "16px 18px",
      boxShadow: "0 8px 40px rgba(0,0,0,0.5)",
      display: "flex", alignItems: "center", gap: 14,
      animation: "fadeUp 0.4s",
    }}>
      {/* Icon */}
      <div style={{
        width: 48, height: 48, borderRadius: 12, flexShrink: 0,
        background: `linear-gradient(135deg, ${B.orange}, ${B.orangeDark})`,
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: 24,
      }}>
        👗
      </div>

      {/* Text */}
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 700, fontSize: 14, color: "#fff", fontFamily: fonts.display, marginBottom: 2 }}>
          Install NS Admin
        </div>
        <div style={{ fontSize: 12, color: "rgba(255,255,255,0.55)", fontFamily: fonts.body }}>
          Add to home screen for quick access
        </div>
      </div>

      {/* Actions */}
      <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
        <button onClick={dismiss}
          style={{ background: "none", border: "1px solid rgba(255,255,255,0.2)", borderRadius: 8, padding: "7px 12px", color: "rgba(255,255,255,0.5)", fontSize: 12, cursor: "pointer", fontFamily: fonts.body }}>
          Later
        </button>
        <button onClick={install}
          style={{ background: B.orange, border: "none", borderRadius: 8, padding: "7px 14px", color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: fonts.body }}>
          Install
        </button>
      </div>
    </div>
  );
}
